<template>
	<b-modal
		header-class="header-class-modal-doc-package"
		:title="FormMSG(1, 'Refuse this expense item')"
		v-model="isOpen"
		size="md"
		centered
		no-close-on-backdrop
		no-close-on-esc
		hide-header-close
		modal-class="mui-animation"
		:fade="false"
	>
		<div :class="$screen.width > 576 ? 'container-layout' : 'container-mobile'">
			<b-row>
				<b-col>
					<pre>{{ expenseItemId }}</pre>
					<b-form-group :label="FormMSG(2, 'Enter your comment')">
						<b-form-textarea
							v-model="comment"
							autocomplete="off"
							rows="3"
							:class="{
								'is-invalid': $v.comment.$error
							}"
						/>
						<div v-if="$v.comment.$error" class="invalid-feedback">
							{{ FormMSG(5, 'Please, comment is required') }}
						</div>
					</b-form-group>
				</b-col>
			</b-row>
		</div>
		<template #modal-footer>
			<div class="w-100 d-flex flex-row justify-content-end align-items-center">
				<b-button size="sm" variant="custom-outline-gray" class="w-138-px" :disabled="watingSubmitForm" @click="emitEventClose" block>
					{{ FormMSG(3, 'Close') }}
				</b-button>
				<b-button
					size="sm"
					variant="custom-primary-blue"
					class="w-138-px ml-2"
					:disabled="watingSubmitForm || $v.$invalid"
					style="margin-top: -1px"
					@click="save"
					block
				>
					{{ FormMSG(4, 'Save') }}
				</b-button>
			</div>
		</template>
	</b-modal>
</template>
<script>
import LanguageMessages from '@/mixins/languageMessages';
import GlobalMixin from '@/mixins/global.mixin';
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import { rejectExpenseItem } from '@/cruds/expense.crud';
import { mapActions } from 'vuex';

export default {
	name: 'RejectExpenseModal',
	mixins: [LanguageMessages, GlobalMixin, validationMixin],
	computed: {
		isOpen: {
			get: function () {
				return this.value;
			},
			set: function (value) {
				return value;
			}
		}
	},
	props: {
		value: {
			type: Boolean,
			required: false,
			default: false
		},
		expenseItemId: {
			type: [Number, String],
			required: true,
			default: 0
		}
	},
	data() {
		return {
			watingSubmitForm: false,
			comment: ''
		};
	},
	mounted() {
		this.$v.$touch();
	},
	methods: {
		...mapActions({
			getNotifications: 'header/getNotifications'
		}),
		emitEventClose() {
			this.comment = '';
			this.$emit('reject-expense-item-modal:close');
		},
		async save() {
			await rejectExpenseItem(this.expenseItemId, this.comment)
				.then(async (record) => {
					await this.getNotifications();
					this.comment = '';
					this.$emit('reject-expense-item-modal:refresh', record);
				})
				.catch((error) => {
					this.comment = '';
					console.log(error);
				});
		}
	},
	validations() {
		return {
			comment: {
				required,
				min: minLength(3)
			}
		};
	}
};
</script>
